<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm8 offset-sm2 pt-5>
        <v-alert :value="true" v-if="error != null" type="error">{{
          error.message
        }}</v-alert>
        <v-alert :value="true" v-if="success != null" type="success">{{
          success.message
        }}</v-alert>

        <v-layout justify-center column>
          <template v-if="ready">
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              @submit="updateUser"
            >
              <h2 class="heading-2 align-left">Contact Permission</h2>

              <h2 class="heading-3 align-left">Club News</h2>
              <div class="body-copy">
                <p>
                  All the latest club news, ticketing information, retail
                  offers, rewards scheme news and competitions. Digital Ads will
                  involve us sending your data to 3rd Party companies to target
                  on our behalf.
                </p>
              </div>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`Email`" v-model="clubEmail"></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`SMS`" v-model="clubSMS"></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`Mail`" v-model="clubDirect"></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`Phone`" v-model="clubPhone"></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`Digital Ads`" v-model="clubAds"></v-switch>
                </v-flex>
              </v-layout>

              <h2 class="heading-3 align-left">
                {{ configStrings.clubName }} Foundation News
              </h2>
              <div class="body-copy">
                <p>
                  Keep me updated by email with the latest news from the
                  {{ configStrings.clubName }} Foundation including Football
                  Development Programmes.
                </p>
              </div>
              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                    :label="`Email`"
                    v-model="foundationEmail"
                  ></v-switch>
                </v-flex>
              </v-layout>

              <h2 class="heading-3 align-left">Partner News</h2>
              <div class="body-copy">
                <p>
                  Receive news, discounts, promotions and targeted
                  communications from {{ configStrings.clubName }} Football Club
                  about their Partners, Sponsors and Rewards Affiliates.
                </p>
              </div>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`Email`" v-model="partnerEmail"></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`SMS`" v-model="partnerSMS"></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`Phone`" v-model="partnerPhone"></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`Mail`" v-model="partnerDirect"></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                    :label="`Digital Ads`"
                    v-model="partnerAds"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <div class="body-copy">
                <p>
                  <a
                    href="https://www.avfc.co.uk/club/legal/privacy-policy"
                    target="_blank"
                    >Click here</a
                  >
                  to see our current list of Partners / Sponsors. Our Partners
                  change regularly, so we update this list at least once every
                  season.
                </p>
              </div>
              <v-layout row align-center mx-1 mt-5>
                <v-spacer />
                <button
                  type="submit"
                  class="button"
                  :disabled="!valid || !ready"
                >
                  Update
                </button>
              </v-layout>
            </v-form>
          </template>

          <template v-else>
            <div class="text-xs-center">
              <v-progress-circular
                :size="50"
                color="accent"
                indeterminate
              ></v-progress-circular>
            </div>
          </template>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "UserProfileContactPrefs",
  data() {
    return {
      ready: false,
      valid: true,
      ssoid: "",
      clubAds: false,
      clubEmail: false,
      clubSMS: false,
      clubPhone: false,
      clubDirect: false,
      partnerEmail: false,
      partnerSMS: false,
      partnerPhone: false,
      partnerDirect: false,
      partnerAds: false,
      foundationEmail: false,
      error: null,
      success: null,
      loading: false,
    };
  },
  created() {
    var vm = this;
    // load this user's latest information
    this.$getCurrentUserAttributes().subscribe(
      (userData) => {
        this.ssoid = userData["sub"];
        var crmURL =
          process.env.VUE_APP_XCM_CRM_API + "/user/preferences/" + this.ssoid;

        //G4 mailing preference retrieval and overwrite
        axios({
          method: "get",
          url: crmURL,
        }).then(function (response) {
          //if g4 daa was set then we usethat
          if (response.data.success === true) {
            var xcmData = response.data.data.Preferences;
            vm.clubEmail =
              xcmData["Email"]["Club Communication"] == "Y" ? true : false;
            vm.clubDirect =
              xcmData["Direct Mail"]["Club Communication"] == "Y"
                ? true
                : false;
            vm.clubPhone =
              xcmData["Phone"]["Club Communication"] == "Y" ? true : false;
            vm.clubSMS =
              xcmData["SMS"]["Club Communication"] == "Y" ? true : false;
            vm.partnerEmail =
              xcmData["Email"]["Partner Communication"] == "Y" ? true : false;
            vm.partnerDirect =
              xcmData["Direct Mail"]["Partner Communication"] == "Y"
                ? true
                : false;
            vm.partnerPhone =
              xcmData["Phone"]["Partner Communication"] == "Y" ? true : false;
            vm.partnerSMS =
              xcmData["SMS"]["Partner Communication"] == "Y" ? true : false;
            vm.clubAds =
              xcmData["Digital Ads"]["Club Communication"] == "Y"
                ? true
                : false;
            vm.foundationEmail =
              xcmData["Email"]["AV Foundation"] == "Y" ? true : false;
            vm.partnerAds =
              xcmData["Digital Ads"]["Partner Communication"] == "Y"
                ? true
                : false;
          } else {
            //otherwise we use what is in sso

            vm.clubEmail =
              userData["custom:club_email"] == "true" ? true : false;
            vm.clubSMS = userData["custom:club_sms"] == "true" ? true : false;
            vm.clubPhone =
              userData["custom:club_phone"] == "true" ? true : false;
            vm.clubDirect =
              userData["custom:club_direct"] == "true" ? true : false;
            vm.partnerEmail =
              userData["custom:partner_email"] == "true" ? true : false;
            vm.partnerSMS =
              userData["custom:partner_sms"] == "true" ? true : false;
            vm.partnerPhone =
              userData["custom:partner_phone"] == "true" ? true : false;
            vm.partnerDirect =
              userData["custom:partner_direct"] == "true" ? true : false;
            vm.clubAds = userData["custom:club_ads"] == "true" ? true : false;
            vm.foundationEmail =
              userData["custom:foundation_email"] == "true" ? true : false;
            vm.partnerAds =
              userData["custom:partner_ads"] == "true" ? true : false;
          }

          // tell the app that we've finished loading
          vm.ready = true;
        });
      },
      (err) => {}
    );
  },
  methods: {
    crmXCMPush(username) {
      var crmXCMPushURL =
        process.env.VUE_APP_XCM_CRM_API + "/user/push/" + username;

      return axios({
        method: "get",
        url: crmXCMPushURL,
      });
    },
    crmPush(username) {
      var vm = this;
      Promise.all([vm.crmXCMPush(username)]).then(function (results) {
        vm.error = null;
        var response = {
          message: "Your contact preferences have been updated successfully.",
        };
        vm.success = response;
        vm.ready = true;
      });
    },
    updateUser(e) {
      e.preventDefault();
      this.ready = false;

      var clubEmail = this.clubEmail.toString();
      var clubSMS = this.clubSMS.toString();
      var clubPhone = this.clubPhone.toString();
      var clubDirect = this.clubDirect.toString();
      var clubAds = this.clubAds.toString();
      var foundationEmail = this.foundationEmail.toString();
      var partnerEmail = this.partnerEmail.toString();
      var partnerSMS = this.partnerSMS.toString();
      var partnerPhone = this.partnerPhone.toString();
      var partnerDirect = this.partnerDirect.toString();
      var partnerAds = this.partnerAds.toString();

      var attributesList = {
        "custom:club_email": clubEmail,
        "custom:club_sms": clubSMS,
        "custom:club_phone": clubPhone,
        "custom:club_direct": clubDirect,
        "custom:club_ads": clubAds,
        "custom:foundation_email": foundationEmail,
        "custom:partner_email": partnerEmail,
        "custom:partner_sms": partnerSMS,
        "custom:partner_phone": partnerPhone,
        "custom:partner_direct": partnerDirect,
        "custom:partner_ads": partnerAds,
      };
      var vm = this;
      this.$updateAttributes(attributesList).subscribe(
        (response) => {
          vm.crmPush(this.ssoid);
        },
        (err) => {
          //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito

          vm.success = null;
          vm.error = err;
          vm.ready = true;
        }
      );
    },
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #eeeeee;
}
</style>